module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Flower2-7d0e6b61962e74751a93effe30fc3264.svg";